var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"routing-animation",rawName:"v-routing-animation",value:({speedModifier: 50, index: 2}),expression:"{speedModifier: 50, index: 2}"}],staticClass:"Button",class:{
        'Button--primary': _vm.primary,
        'Button--secondary': _vm.secondary,
        'Button--tertiaryWhite': _vm.tertiaryWhite,
        'Button--tertiaryBlue': _vm.tertiaryBlue,
        'Button--large': _vm.large,
        'Button--small': _vm.small
    },attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }